export const STORAGE_KEY = 'display-whats-new-notification';
